import { selectorFamily, atom } from 'recoil';
import { ObeService } from 'api';
import EnumObeStatus from 'constants/obeStatuses';
import isObeMovable from 'utils/obes/isObeMovable';

// Increments by offset * paginationOffset
export const obesPagination = atom({
  key: 'obesPagination',
  default: {
    max: 1000,
    // this is needed for a dropdown to show all obes
    offset: 0
  }
});
export const getObesForCustomerRequestIdState = atom({
  key: 'getObesForCustomerRequestIdState',
  default: 0
});
const getObesForCustomer = selectorFamily({
  key: 'getObesForCustomer',
  get: customerId => async ({
    get
  }) => {
    if (!customerId) return {};
    get(getObesForCustomerRequestIdState);
    const {
      max,
      offset
    } = get(obesPagination);
    const body = {
      max,
      offset
    };
    try {
      return await ObeService.getObesWithQuery({
        customerId,
        body
      });
    } catch (e) {
      console.error(`${e}: Could not fetch OBEs for customerId`, customerId);
    }
    return {};
  }
});
export const getActiveObesForCustomer = selectorFamily({
  key: 'getActiveObesForCustomer',
  get: customerId => async ({
    get
  }) => {
    if (!customerId) return [];
    get(getObesForCustomerRequestIdState);
    try {
      const obes = get(getObesForCustomer(customerId));
      const activeObes = obes?.results?.filter(obe => isObeMovable(obe));
      return activeObes;
    } catch (e) {
      return [];
    }
  }
});
export const getInactiveObesForCustomer = selectorFamily({
  key: 'getInactiveObesForCustomer',
  get: customerId => async ({
    get
  }) => {
    if (!customerId) return [];
    get(getObesForCustomerRequestIdState);
    try {
      const obes = get(getObesForCustomer(customerId));
      const inactiveObes = obes?.results?.filter(obe => obe.obeStatus === EnumObeStatus.Inactive);
      return inactiveObes;
    } catch (e) {
      return [];
    }
  }
});
export default getObesForCustomer;